const URL_REGEX = /url="([^"]+)"/g;

export const extractLuminaUrls = (luminaContentMap: Record<string, string>): string[] => {
	const urls: string[] = [];
	for (const value of Object.values(luminaContentMap)) {
		for (const match of value.matchAll(URL_REGEX)) {
			urls.push(match[1]);
		}
	}
	return urls;
};
